import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Checkbox, Collapse, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import React, { Dispatch, useState } from "react";

import { UserTeam } from "./IvrUserSkillsConfig";
import IvrUserSkillsConfigCard from "./IvrUserSkillsConfig.Card";

interface IvrUserSkillsConfigUsersList {
  ivrUserTeams?: UserTeam[];
  isDisabled: boolean;
  onChange: Dispatch<UserTeam[]>;
}

const IvrUserSkillsConfigUsersList: React.FC<IvrUserSkillsConfigUsersList> = ({
  isDisabled,
  ivrUserTeams,
  onChange
}) => {
  const [expandIndex, setExpandIndex] = useState(-1);

  const toggleAllTeamUsers = (index: number, selected: boolean) => {
    if (!ivrUserTeams) return ivrUserTeams;
    ivrUserTeams[index].users = ivrUserTeams[index].users.map(({ user }) => ({ user, selected }));
    onChange([...ivrUserTeams]);
  };
  const toggleUser = (teamIndex: number, userIndex: number) => () => {
    if (!ivrUserTeams) return ivrUserTeams;
    ivrUserTeams[teamIndex].users[userIndex].selected = !ivrUserTeams[teamIndex].users[userIndex].selected;
    onChange([...ivrUserTeams]);
  };
  const handleExpandTeam = (index: number) => () => setExpandIndex(oldIndex => (oldIndex === index ? -1 : index));
  const usersSelectedCount = ivrUserTeams?.reduce(
    (count, { users }) => count + users.filter(u => u.selected).length,
    0
  );

  return (
    <IvrUserSkillsConfigCard
      isLoading={!ivrUserTeams}
      title="Users"
      subheader={usersSelectedCount ? `${usersSelectedCount} Selected` : undefined}
    >
      <Table
        sx={isDisabled ? { filter: "grayscale(100%)", userSelect: "none", pointerEvents: "none" } : undefined}
        stickyHeader
        size="small"
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: ".01%", whiteSpace: "nowrap" }} padding="checkbox"></TableCell>
            <TableCell>Team</TableCell>
            <TableCell align="right" padding="checkbox"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ivrUserTeams?.map(({ team, users }, teamIndex) => (
            <React.Fragment key={teamIndex}>
              <TableRow>
                <TableCell
                  sx={{ width: ".01%", whiteSpace: "nowrap" }}
                  padding="checkbox"
                  onClick={handleExpandTeam(teamIndex)}
                >
                  {(teamIndex === expandIndex && <ExpandLessIcon />) || <ExpandMoreIcon />}
                </TableCell>
                <TableCell onClick={handleExpandTeam(teamIndex)}>{team}</TableCell>
                <TableCell align="right" padding="checkbox">
                  <Checkbox
                    checked={!users.some(({ selected }) => !selected)}
                    onChange={({ target: { checked } }) => toggleAllTeamUsers(teamIndex, checked)}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                  <Collapse in={teamIndex === expandIndex} timeout="auto" unmountOnExit>
                    <Table size="small" padding="none">
                      <TableHead>
                        <TableRow>
                          <TableCell>User Name</TableCell>
                          <TableCell padding="checkbox"></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {users.map(({ user, selected }, userIndex) => (
                          <TableRow hover key={userIndex} onClick={toggleUser(teamIndex, userIndex)}>
                            <TableCell>{`${user.firstName} ${user.lastName}`}</TableCell>
                            <TableCell padding="checkbox">
                              <Checkbox checked={selected} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Collapse>
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </IvrUserSkillsConfigCard>
  );
};

export default IvrUserSkillsConfigUsersList;
